import { LANDING_TYPE_CONTENT } from "../../data/interfaces"

export const parseValue = (type: string, value: any): any => {
    switch(type) {
        case LANDING_TYPE_CONTENT.IMAGE:
            return value.src 
        case LANDING_TYPE_CONTENT.ICON:
            return value 
        case LANDING_TYPE_CONTENT.HTML:
        default:
            return value
    }
}
export const parseField = (type: string ): any => {
    switch(type) {
        case LANDING_TYPE_CONTENT.IMAGE:
            return "src"
        case LANDING_TYPE_CONTENT.ICON:
            return ""
        case LANDING_TYPE_CONTENT.HTML:
        default:
            return ""
    }
}
